var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoWhatsApp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.411621 46.0886L3.58873 34.4886C1.62595 31.0857 0.594968 27.2254 0.599709 23.297C0.604883 10.9538 10.6496 0.912109 22.9932 0.912109C28.9831 0.915153 34.6053 3.24617 38.8337 7.47754C43.062 11.7089 45.3884 17.3333 45.3863 23.315C45.3808 35.6573 35.3345 45.7008 22.9929 45.7008H22.9831C19.2357 45.6993 15.5533 44.7592 12.2825 42.9757L0.411621 46.0886Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 4.69341C12.7333 4.69341 4.38404 13.0396 4.38039 23.2983C4.37533 26.8014 5.3618 30.2343 7.22576 33.2003L7.66859 33.9043L5.78801 40.7698L12.8325 38.9227L13.5127 39.3257C16.3696 41.0212 19.6454 41.9178 22.9859 41.9197H22.9929C33.2516 41.9197 41.6008 33.5726 41.6048 23.3132C41.6125 20.868 41.1352 18.4454 40.2003 16.1859C39.2654 13.9264 37.8916 11.8748 36.1585 10.1498C34.4349 8.41539 32.3844 7.04008 30.1258 6.10349C27.8671 5.1669 25.4451 4.68762 22.9999 4.69341Z",
    fill: "url(#paint0_linear_8189_45895)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3958 13.9387C16.9764 13.0071 16.5351 12.9882 16.1367 12.9721L15.0642 12.959C14.6911 12.959 14.0848 13.099 13.5723 13.659C13.0597 14.219 11.6138 15.5724 11.6138 18.3253C11.6138 21.0781 13.6188 23.7381 13.8982 24.1119C14.1776 24.4856 17.7689 30.3148 23.4563 32.5576C28.1826 34.4214 29.1443 34.0507 30.1706 33.9576C31.1969 33.8645 33.481 32.6042 33.947 31.2976C34.4129 29.991 34.4132 28.8716 34.2735 28.6376C34.1338 28.4035 33.7607 28.2644 33.2007 27.9844C32.6407 27.7044 29.8903 26.351 29.3775 26.1641C28.8646 25.9772 28.4918 25.8844 28.1184 26.4444C27.7449 27.0044 26.6739 28.2641 26.3473 28.6376C26.0208 29.011 25.6948 29.0579 25.1348 28.7782C24.5748 28.4985 22.7731 27.9074 20.6353 26.0013C18.972 24.5182 17.8493 22.6866 17.5224 22.1269C17.1955 21.5672 17.4877 21.2641 17.7683 20.9853C18.0194 20.7345 18.3277 20.3319 18.608 20.0053C18.8883 19.6787 18.9806 19.4453 19.1668 19.0725C19.3531 18.6996 19.2603 18.3722 19.1203 18.0925C18.9803 17.8128 17.8931 15.0453 17.3958 13.9387Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8189_45895",
    x1: 22.614,
    y1: 6.927,
    x2: 22.802,
    y2: 38.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoWhatsApp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_whats_app.b4d6b353d6513ad2bdf3380a227395cc.svg";